module.exports = __webpack_public_path__ + "img/bocejando.f00c5bf7.png";